module.exports = __webpack_public_path__ + "img/gbwhatsapp-qr-code-gbwhatapks.9990892d.webp";